import { Button } from 'antd';
import styled from 'styled-components';
import { StyledTableWrapper } from 'components/new-ui/base/table/styles';
import { StyledModal } from 'components/new-ui/composed/modal/confirmation-modal/styles';

export const Box44FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const SBox44Button = styled(Button)`
    padding: 8px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;

    color: var(--brand-6);
    border: 1px solid var(--brand-6);
    font-weight: 400;

    :hover {
        background-color: var(--brand-6);
        color: white;
    }

    :focus {
        color: white;
        background-color: var(--brand-7);
        border: 1px solid var(--brand-6);
    }
`;

export const Box44StyledModal = styled(StyledModal)`
    .ant-modal-header {
        padding: 24px 40px;
    }

    .ant-modal-close {
        top: 13px;
        right: 20px;
    }
`;

export const Box44StyledTableWrapper = styled(StyledTableWrapper)`
    .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }
`;
